var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "goback-a",
    transform: "translate(8 23)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.113 29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "goback-b",
    d: "M54.273,6.429l4.9,5.395a.517.517,0,0,0,.779,0,.649.649,0,0,0,0-.856L55.44,6l4.511-4.967a.649.649,0,0,0,0-.857.517.517,0,0,0-.779,0l-4.9,5.395A.656.656,0,0,0,54.273,6.429Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoback);
export default __webpack_public_path__ + "static/media/goback.23734963400a27739d85615d09023f87.svg";
export { ForwardRef as ReactComponent };